import moment from 'moment-timezone';
import { toast } from 'react-toastify';
import { dateTimeConstants } from '_constants';

export function handleErrorResponse(response) {
  if (typeof response.message === 'string') {
    // When response.message is a string
    toast.error(response.message);
  } else if (typeof response.message === 'object') {
    // When response.message is an object
    const errorMessages = Object.values(response.message).flat();
    errorMessages.forEach((errorMessage) => {
      toast.error(errorMessage);
    });
  } else {
    // Unexpected response structure
    toast.error('Something went wrong! please contact support team!');
  }
}

export const preventNegativeValueInDocs = (e) => {
  if (
    e.key === 'ArrowDown' ||
    e.key === 'ArrowUp' ||
    e.key === '-' ||
    e.key === 'e'
  ) {
    e.preventDefault();
  }
};

export function checkPastDate(input) {
  if (!input) return false;
  const date = moment(input);
  if (!date.isValid()) return false; // Prevents invalid date errors
  return date.isBefore(moment(), 'day'); // Compares only the date, ignoring time
}

export const getCurrentDatePST = () => {
  const date = new Date();
  const options = {
    timeZone: dateTimeConstants.PST_TIMEZONE,
    year: dateTimeConstants.NUMERIC_FORMAT,
    month: dateTimeConstants.TWO_DIGIT_FORMAT,
    day: dateTimeConstants.TWO_DIGIT_FORMAT,
  };
  const formattedDate = date.toLocaleString(
    dateTimeConstants.LOCALE_DATE_STRING_FORMAT,
    options
  );

  return formattedDate.split(',')[0]; // Remove time part
};

export const formatSSN = (ssn) => {
  if (!ssn) return ''; // Return empty if ssn is not available
  return `${ssn.slice(0, 3)}-${ssn.slice(3, 5)}-${ssn.slice(5)}`;
};

export const formatPhone = (phone) => {
  if (!phone) return '';
  return `${phone.slice(0, 3)}-${phone.slice(3, 6)}-${phone.slice(6)}`;
};

export const getStandardCurrentDatePST = () => {
  const date = new Date();
  const options = {
    timeZone: dateTimeConstants.PST_TIMEZONE,
    year: 'numeric', // Ensure full numeric year
    month: '2-digit', // Two-digit month
    day: '2-digit', // Two-digit day
  };

  // Get the date parts
  const [month, day, year] = date
    .toLocaleDateString(dateTimeConstants.LOCALE_DATE_STRING_FORMAT, options)
    .split('/');
  // Format the date as yyyy-mm-dd
  return `${year}-${month}-${day}`;
};

export const convertDateTimeToPST = (dateTime) => {
  const momentDateTime = moment.utc(dateTime);
  if (momentDateTime.isValid()) {
    return momentDateTime
      .tz(dateTimeConstants.PST_TIMEZONE)
      .format(dateTimeConstants.DATE_TIME_FORMAT);
  }
  return '-';
};

export const formatDate = (date) => {
  if (!date) {
    return '-';
  }
  const momentDate = moment(date);
  if (momentDate.isValid()) {
    return momentDate.format(dateTimeConstants.DATE_FORMAT);
  }
};
